var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcUser2 = function SvgIcUser2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.55 19.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3 16.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75ZM12.79 2.75a3.678 3.678 0 0 0-3.68 3.687v.003a3.67 3.67 0 0 0 3.505 3.679c.118-.008.244-.009.362 0A3.677 3.677 0 0 0 16.48 6.44a3.693 3.693 0 0 0-3.69-3.69ZM7.61 6.442a5.178 5.178 0 0 1 5.18-5.192 5.193 5.193 0 0 1 5.19 5.19 5.177 5.177 0 0 1-4.995 5.18.758.758 0 0 1-.1-.004 1.077 1.077 0 0 0-.187 0 .76.76 0 0 1-.093.004A5.17 5.17 0 0 1 7.61 6.442Z",
    fill: "#123862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.785 13.93c-1.701 0-3.362.433-4.588 1.253l-.002.001c-1.053.701-1.48 1.551-1.48 2.307s.427 1.61 1.481 2.315c1.232.821 2.889 1.254 4.594 1.254a.75.75 0 1 1 0 1.5c-1.935 0-3.898-.487-5.426-1.506h-.001c-1.366-.915-2.148-2.191-2.148-3.563 0-1.371.783-2.646 2.149-3.555 1.524-1.02 3.492-1.506 5.42-1.506 1.93 0 3.899.487 5.423 1.507a.75.75 0 1 1-.834 1.246c-1.226-.82-2.887-1.253-4.588-1.253Z",
    fill: "#123862"
  })));
};
export default SvgIcUser2;